// Voucher type translation key helpers
// Voucher types are runtime values, but we only have translations for a finite set of known keys.
type VoucherTypeName = 'omni' | 'online' | 'selfcheckout' | 'selfscan';
type VoucherTypeSubKey = 'text' | 'requirements' | 'validIn';
export type VoucherTypeKey = `${VoucherTypeName}.${VoucherTypeSubKey}`;

export const isVoucherTypeName = (value: string): value is VoucherTypeName => {
  return value === 'omni' || value === 'online' || value === 'selfcheckout' || value === 'selfscan';
};

export const getVoucherTypeKey = (type: string, subKey: VoucherTypeSubKey): VoucherTypeKey => {
  if (!isVoucherTypeName(type)) {
    console.warn(`Invalid voucher type: ${type}`);
    return null as unknown as VoucherTypeKey;
  }
  return `${type}.${subKey}`;
};
